/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ContemporaryLandingProductsModule_contemporaryLandingRow$ref: FragmentReference;
export type ContemporaryLandingProductsModule_contemporaryLandingRow = {|
  +items: ?$ReadOnlyArray<?{|
    +text?: ?string,
    +type?: ?string,
    +items?: ?$ReadOnlyArray<?{|
      +brand?: ?string,
      +contemporaryTrackingString?: ?string,
      +imagePath?: ?string,
      +itemPk?: ?string,
      +link?: ?string,
      +netPrice?: ?string,
      +retailPrice?: ?string,
      +title?: ?string,
    |}>,
  |}>,
  +$refType: ContemporaryLandingProductsModule_contemporaryLandingRow$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "ContemporaryLandingProductsModule_contemporaryLandingRow",
  "type": "ContemporaryLandingRow",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "items",
      "storageKey": null,
      "args": null,
      "concreteType": null,
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "type": "ContemporaryLandingRow",
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "items",
              "storageKey": null,
              "args": null,
              "concreteType": null,
              "plural": true,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "type": "ContemporaryLandingProductRowItem",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "brand",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "contemporaryTrackingString",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "imagePath",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "itemPk",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "link",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "netPrice",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "retailPrice",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "title",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            },
            (v0/*: any*/)
          ]
        },
        {
          "kind": "InlineFragment",
          "type": "ContemporaryLandingHeader",
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "text",
              "args": null,
              "storageKey": null
            },
            (v0/*: any*/)
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '110f5f7307430638050a46e8cdd082f3';
module.exports = node;
